import mentorshipGroupParticipants from './mentorship-group-participants';
import programParticipants from './program-participants';
import meetings from './meetings';

export default {
  ...meetings,
  ...mentorshipGroupParticipants,
  ...programParticipants,
};

